<script>
import Pagination from "./InductionPagination";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import InductionAPI from "@/services/standards/inductionProgram/inductionProgramAPI";

export default {
  components: { Pagination },
  props: {
    companyID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      themes: [],
      search: null,
      loading: true,

      classificationID:
        this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      itemData: null,
    };
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(10)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteInduccion(id) {
      InductionAPI.delete(id)
        .then((data) => {
          Swal.fire({
            title: "Se ha sido eliminado con exito!",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();

        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    print(evidence) {
      if (evidence) {
        window.location.href = evidence;
      }
    },

    getThemeID(theme) {
      if (theme === "INDUCCIÓN") {
        return 1;
      } else if (theme === "REINDUCCIÓN") {
        return 2;
      } else if (theme === "GENERAL") {
        return 3;
      } else {
        return 4;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },
  },
  mounted() {
    this.getItemData();
  },
};
</script>

<template>
  <div>
    <div v-if="!loading && classificationID !== 5">
      <table
        class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
        <thead class="table-active">
          <tr>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
              Fecha inicio de capacitación
            </th>

            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
              Fecha fin de Capacitación
            </th>

            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
              Nombre de la Capacitación
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-8">
              Observaciones
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
              Evidencia
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
              Acciones
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="item in themes" :key="item.id">
            <td class="px-6 text-sm text-gray-500 mx-2">
              {{ dateConvert(item.induction_date) }}

            </td>

            <td class="px-6 text-sm text-gray-500 mx-2">
              {{ dateConvert(item.induction_date) }}

            </td>

            <td class="px-6 text-sm text-gray-500 mx-2">
              <b>
                Tema: <!-- {{ getThemeID(item.induction_theme) }} -->
                {{ item.induction_theme }}
              </b>
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2">
              {{ item.observations }}
            </td>

            <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
              <button :disabled="!allowAccess() || !getRole('Consultar') || !item.evidence" :id="`evidence${item.id}`"
                type="button" :class="
                  item.evidence
                    ? `btn btn-outline-primary btn-md`
                    : `btn btn-secondary btn-md`
                " @click="print(item.evidence)">
                <i class="bx bx-download"></i>
              </button>
              <b-tooltip :target="`evidence${item.id}`"> Descargar evidencia </b-tooltip>
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
              <div class="col-sm-12">
                <b-dropdown variant="primary" :disabled="!allowAccess() || !getRole('Editar')">
                  <template v-slot:button-content>
                    <i class="mdi mdi-eye"></i>
                  </template>
                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')" v-b-modal="`modal${item.id}`">
                    Editar
                  </b-dropdown-item>
                  <b-modal :id="`modal${item.id}`" body-class="p-4" hide-header hide-footer size="sm">
                    <div class="text-justify">
                      <h4 class="mt-2 text-primary text-center">Advertencia</h4>
                      <p class="mt-3">
                        Al modificar esta información se quitará el puntaje
                        correspondiente a este ítem y será necesario realizar nuevamente
                        la validación por parte del usuario responsable de Emisión.
                      </p>
                      <button type="button" @click="
                        goPage(`/forms/estandares/${companyID}/induccion/${item.id}`)
                      " class="btn btn-primary my-2 mx-2" data-dismiss="`modal${item.id}`"
                        :disabled="!allowAccess()">
                        Continuar
                      </button>
                      <button type="button" @click="$bvModal.hide(`modal${item.id}`)" class="btn btn-danger btn mx-2"
                        data-dismiss="modal">
                        Cancelar
                      </button>
                    </div>
                  </b-modal>
                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')" v-b-modal="`modal${item.id}`">
                    Ver
                  </b-dropdown-item>
                  <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                      v-on:click="deleteInduccion(item.id)">Eliminar</b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>

    <Pagination ref="paginator" @loading="(load) => (loading = load)" :search="search"
      @fetch="(items) => (themes = items)" />
  </div>
</template>


